import { ConsentResolvedCallback } from "../types";

export interface ConsentProviderInterface {
  subscribe: (callback: ConsentResolvedCallback) => void;
}

export interface ConsentStubProviderInterface {
  getConsentApi: () => "tcf" | "usp" | undefined;
  getConsentString: () => string | undefined;
  getConsents: (optOut: boolean) => Required<Categories> | undefined;
}

export const isConsentStubProvider = (
  provider: ConsentProviderInterface | ConsentStubProviderInterface | null,
): provider is ConsentStubProviderInterface => {
  return Boolean(
    provider &&
      "getConsentApi" in provider &&
      "getConsentString" in provider &&
      "getConsents" in provider,
  );
};
